import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock, FaWhatsapp, FaInstagram, FaFacebook, FaLinkedin } from 'react-icons/fa';
import './Footer.css';

const footerLinks = [
  { path: '/', key: 'nav.home' },
  { path: '/nos-services', key: 'nav.services' },
  { path: '/vivre-en-espagne', key: 'nav.vivre' },
  { path: '/reconnaissance-des-diplomes', key: 'nav.reconnaissance' },
  { path: '/documents-demarches', key: 'nav.documents' },
  { path: '/diagnostic', key: 'nav.diagnostic' },
  { path: '/collaborateurs', key: 'nav.collaborateurs' },
  { path: '/temoignages', key: 'nav.temoignages' },
  { path: '/paiement', key: 'nav.paiement' },
  { path: '/consultoria-marruecos', key: 'nav.consultoria' },
];

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-md-6 mb-4">
            <h5 className="footer-title">{t('footer.brand')}</h5>
            <p className="footer-description">{t('footer.description')}</p>
          </div>

          <div className="col-lg-4 col-md-6 mb-4">
            <h5 className="footer-title">{t('common.contactInfo')}</h5>
            <div className="contact-info">
              <div className="contact-item">
                <FaMapMarkerAlt className="contact-icon" />
                <div>
                  <strong>{t('common.officeSpain')}</strong>
                  <p>{t('footer.addressSpain')}</p>
                </div>
              </div>
              <div className="contact-item">
                <FaMapMarkerAlt className="contact-icon" />
                <div>
                  <strong>{t('common.officeMorocco')}</strong>
                  <p>{t('footer.addressMorocco')}</p>
                </div>
              </div>
              <div className="contact-item">
                <FaPhone className="contact-icon" />
                <p>{t('footer.phoneSpain')}</p>
                <p>{t('footer.phoneMorocco')}</p>
              </div>
              <div className="contact-item">
                <FaEnvelope className="contact-icon" />
                <p>{t('footer.email')}</p>
              </div>
              <div className="contact-item">
                <FaClock className="contact-icon" />
                <p>{t('common.hours')}</p>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 mb-4">
            <h5 className="footer-title">{t('common.usefulLinks')}</h5>
            <ul className="footer-links">
              {footerLinks.map((item) => (
                <li key={item.path}>
                  <Link to={item.path}>{t(item.key)}</Link>
                </li>
              ))}
            </ul>

            <h5 className="footer-title mt-4">{t('common.followUs')}</h5>
            <div className="social-icons">
              <a href="https://wa.me/212669032828" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label={t('common.whatsapp')}>
                <FaWhatsapp />
              </a>
              <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label={t('common.instagram')}>
                <FaInstagram />
              </a>
              <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label={t('common.facebook')}>
                <FaFacebook />
              </a>
              <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label={t('common.linkedin')}>
                <FaLinkedin />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="row">
            <div className="col-md-6">
              <p>{t('common.copyright')}</p>
            </div>
            <div className="col-md-6 text-md-end">
              <Link to="/mentions-legales">{t('common.legalNotice')}</Link>
              <span className="separator">|</span>
              <Link to="/politique-confidentialite">{t('common.privacyPolicy')}</Link>
              <span className="separator">|</span>
              <Link to="/rgpd">{t('common.gdpr')}</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
